'use strict';

import YearlyTotalsModalView from './YearlyTotalsModal.js';
import template from '../../templates/employee/PreviousPayslips.ejs';
import moment from 'moment';
import tooltip from 'helpers/tooltip.js';
import localStorageUtil from 'helpers/localStorageUtil.js';
import Payroll from 'newModels/payroll.js';

module.exports = Backbone.View.extend({
    previousEmploymentModal: null,
    currentEmploymentModal: null,

    events: function() {
        return {
            'click .js-previous-employment': 'showPreviousEmploymentModal',
            'click .js-current-employment':  'showCurrentEmploymentModal',
            'change .js-ytd-year': 'changeYtdYear'
        };
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            payrollItems: null,
            yearlyTotals: null,
            payslips: null,
            payslipAttachments: null,
            isNew: null,
            year: new Date().getFullYear()
        });

        this.options.yearlyTotals.reset(
            _.sortBy(this.options.yearlyTotals.models, function(item) {
                return -item.get('amount');
            }),
            {silent: true}
        );

        this.previousEmploymentModal = new YearlyTotalsModalView({
            current: false,
            collection: this.options.yearlyTotals,
            payrollItems: this.options.payrollItems,
            model: this.model,
            year: this.options.year,
            unsubmittedPayroll: this.options.unsubmittedPayroll
        });

        this.currentEmploymentModal = new YearlyTotalsModalView({
            current: true,
            collection: this.options.yearlyTotals,
            payrollItems: this.options.payrollItems,
            model: this.model,
            year: this.options.year,
            unsubmittedPayroll: this.options.unsubmittedPayroll
        });

        this.options.yearlyTotals.on('all', this.render, this);

        this.render();

        return this;
    },

    render: function() {
        let periodStart = moment(Payroll.getCurrentPeriodDate());
        let yearStart = moment(periodStart).date(1).month(0);
        let joinDate = new Date(this.model.get('commencementDate'));

        this.$el.html(template({
            model: this.model,
            selectedYear: this.options.year,
            ytdYears: _.times(
                Math.max(
                    1,
                    moment().year() - Math.max(2016, joinDate.getFullYear()) + 1
                ),
                i => moment().year() - i
            ),
            isNew: this.options.isNew,
            itemYearlyTotals: this.options.yearlyTotals,
            payslips: this.options.payslips,
            payslipAttachments: this.options.payslipAttachments,

            showPreviousEmployment: (
                joinDate &&
                moment(joinDate).isSame(periodStart, 'year') &&
                yearStart.isBefore(joinDate)
            ),
            showCurrentEmployment: (
                joinDate && moment(joinDate)
                    .isSameOrBefore(periodStart, 'month')
            )
        }));

        tooltip.init(this);

        return this;
    },

    showPreviousEmploymentModal: function(ev) {
        ev.preventDefault();
        this.previousEmploymentModal.show();
    },

    showCurrentEmploymentModal: function(ev) {
        ev.preventDefault();
        this.currentEmploymentModal.show();
    },

    changeYtdYear: function(ev) {
        ev.preventDefault();
        localStorageUtil.setItem('ytdYear', ev.target.value);
        Backbone.history.loadUrl(Backbone.history.fragment);
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/employee/PreviousPayslips.js